import React from "react";
import { useTranslation } from "react-i18next";
import { TimeUnit } from "components/common";
import { Alert } from "components/bootstrap";
const BLOCKLIST_TYPE = {
  DOMAINS: "abusech_ransom_adapter_summary.domains_blocklist",
  URLS: "abusech_ransom_adapter_summary.urls_blocklist",
  IPS: "abusech_ransom_adapter_summary.ips_blocklist"
};
const AbuseChRansomAdapterSummary = ({ dataAdapter: { config } }) => {
  const { t } = useTranslation("integrations");
  const blocklistTypeKey = BLOCKLIST_TYPE[config.blocklist_type];
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, t("abusech_ransom_adapter_summary.blocklist_type_label")), /* @__PURE__ */ React.createElement("dd", null, blocklistTypeKey && t(blocklistTypeKey)), /* @__PURE__ */ React.createElement("dt", null, t("abusech_ransom_adapter_summary.update_interval_label")), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement(TimeUnit, { value: config.refresh_interval, unit: config.refresh_interval_unit }))), /* @__PURE__ */ React.createElement(
    Alert,
    {
      style: { marginBottom: 10 },
      bsStyle: "warning",
      title: t("abusech_ransom_adapter_summary.deprecation_title")
    },
    /* @__PURE__ */ React.createElement("p", null, t("abusech_ransom_adapter_summary.deprecation_text"))
  ));
};
export default AbuseChRansomAdapterSummary;
